import type { LandingOverrideComponent } from '@/types/client-landing'
import { LumieEarlyAccessLanding } from '@/components/landing/lumie/lumie-early-access-landing'
import { YeshumanWorkbenchLanding } from '@/components/landing/yeshuman/yeshuman-workbench-landing'

/**
 * Optional full-page landing overrides per `landing.landingComponent` key.
 * Add entries when a tenant needs a bespoke layout that JSON blocks cannot express.
 */
export const LANDING_OVERRIDES: Record<string, LandingOverrideComponent> = {
  lumieEarlyAccess: LumieEarlyAccessLanding,
  yeshumanWorkbench: YeshumanWorkbenchLanding,
}
